<template>
  <div class="d-flex flex-column px-8 mb-14" :style="cardStyle" key="item.id_colaboracao">
    <section>
      <div class="header d-flex align-center justify-center">
        <span class="nome-colaborador"
          ><template v-if="flgExibirUf && item.sigla_estado_colaborador">
            {{ `${item.dsc_nome_colaborador} - ${item.sigla_estado_colaborador}` }}
          </template>
          <template v-else>
            {{ item.dsc_nome_colaborador }}
          </template></span
        >
      </div>
      <div class="text align-center justify-center d-flex">
        <div class="inner-text d-flex align-center justify-center">
          <div class="audio-box d-flex align-center justify-center">
            <audio
              controls
              controlslist="nodownload"
              autoplay
              width="250"
              height="45"
              style="height: 40px !important"
              :key="item.url_midia_colaboracao"
            >
              <source :src="item.url_midia_colaboracao" />
            </audio>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    posicaoCard: String,
    isFullScreen: Boolean,
    hideUserInfo: Boolean,
    flgExibirUf: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    cardStyle() {
      const position =
        this.posicaoCard === "esquerda" && !this.item.url_midia_colaboracao
          ? "margin-left: 100px; justify-self: flex-start"
          : this.posicaoCard === "centro"
          ? "justify-self: center"
          : this.posicaoCard === "direita" && !this.item.url_midia_colaboracao
          ? "margin-right: 40px; justify-self: flex-end"
          : this.posicaoCard === "direita" && this.item.url_midia_colaboracao
          ? "margin-right: 60px; justify-self: flex-start"
          : this.posicaoCard === "esquerda" && this.item.url_midia_colaboracao
          ? "margin-left: 120px; justify-self: flex-start"
          : "";

      const array = position.split(";");
      return array.filter((item) => item).join(";");
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Kallisto";
  src: url("@/assets/fonts/kallisto-medium.otf") format("opentype");
}

@font-face {
  font-family: "Kallisto Bold Italic";
  src: url("@/assets/fonts/kallisto-bold-italic.otf") format("opentype");
}

@font-face {
  font-family: "Kallisto Heavy";
  src: url("@/assets/fonts/kallisto-heavy.otf") format("opentype");
}

.header {
  width: 280px;
  height: 50px;
  background-color: #001169;
  -moz-transform: skew(-1deg, -4deg);
  -webkit-transform: skew(-1deg, -4deg);
  -o-transform: skew(-1deg, -4deg);
  -ms-transform: skew(-1deg, -4deg);
  transform: skew(-1deg, -4deg);
  box-shadow: 3px 7px 0px #70fdeb;
}

.text {
  width: 320px;
  height: 65px;
  background-color: #25ff6c;
  -moz-transform: skew(-1deg, -4deg);
  -webkit-transform: skew(-1deg, -4deg);
  -o-transform: skew(-1deg, -4deg);
  -ms-transform: skew(-1deg, -4deg);
  transform: skew(-1deg, -4deg);
}

.inner-text {
  width: 280px;
  height: 50px;
  background-color: #dcffca;
  border-radius: 40px;
}

.nome-colaborador {
  color: #dcffca !important;
  -webkit-text-stroke: 0.2px #25ff6c;
  font-family: "Kallisto Heavy" !important;
  font-size: 1.5rem;
}

.audio-box {
  width: 260px;
  height: 40px;
}

audio::-webkit-media-controls-panel {
  width: 100%;
  height: 100%;
}
</style>
